import Image from "next/image";
import heroImage from "@/public/img/products/products-collage.png";

const ProductsHeadingSection = () => {
  return (
    <section className="relative flex h-60 w-full flex-col items-center justify-center bg-black/50">
      <Image
        src={heroImage}
        alt=""
        priority
        fill
        placeholder="blur"
        className="absolute inset-0 -z-10 h-full w-full object-cover object-center"
        sizes="(max-width: 600px) 600px, (max-width: 900px) 900px, (max-width: 1200px) 1200px, (max-width: 1500px) 1500px, 2000px"
      />
      <h1 className="z-10 pt-0 text-4xl font-bold text-white sm:text-5xl md:text-6xl">
        Products
      </h1>
    </section>
  );
};

export default ProductsHeadingSection;
